export const EXPORT_DATA_TYPES = {
  PLAN_AND_RECORD: 'planAndRecord',
  PLAN_DETAIL: 'planDetail',
} as const
